<template>
<v-card class="tabbed-feedback">
  <v-tabs centered icons-and-text @change="tabNavigated">
    <v-tabs-slider :color="themes.client.light.primary"></v-tabs-slider>
    <v-tab href="#notes">
      Notes
      <v-badge right :color="themes.client.light.badge">
        <v-icon>mdi-note-multiple</v-icon>
        <span slot="badge">{{ activities.length }}</span>
      </v-badge>
    </v-tab>
    <v-tab href="#chats">
      Chat
      <v-badge right :color="unreadCandidateChats ? 'deep-orange' : themes.client.light.badge">
        <v-icon>mdi-chat</v-icon>
        <span slot="badge" v-if="chats.length > 0">{{ chats.length }}</span>
      </v-badge>
    </v-tab>
    <v-tab-item value="notes">
      <v-divider v-if="showOpportunityTabs" />
      <v-btn-toggle v-if="showOpportunityTabs" flat mandatory v-model="allOpportunities" class="elevation-0" style="width: 100%">
        <v-btn flat small :value="false">
          This Opportunity
        </v-btn>
        <v-btn flat small :value="true">
          All Opportunities
        </v-btn>
      </v-btn-toggle>
      <ApplicationNotes :application="application" :readonly="readonly" :allOpportunities="allOpportunities" @toggleAll="toggleAll" />
    </v-tab-item>
    <v-tab-item value="chats">
      <v-divider v-if="showOpportunityTabs" />
      <v-btn-toggle v-if="showOpportunityTabs" flat mandatory v-model="allOpportunities" class="elevation-0" style="width: 100%">
        <v-btn flat small :value="false">
          This Opportunity
        </v-btn>
        <v-btn flat small :value="true">
          All Opportunities
        </v-btn>
      </v-btn-toggle>
      <ApplicationConversation :application="application" :chats="chats" />
    </v-tab-item>
  </v-tabs>
</v-card>
</template>

<script>
// Components
import ApplicationConversation from '@/components/client/applications/ApplicationConversation'
import ApplicationNotes from '@/components/client/applications/ApplicationNotes'

// Helpers
import { mapGetters } from 'vuex'
import colors from '@/data/colors'
import _ from 'lodash'

export default {
  props: { application: Object, readonly: { type: Boolean, default: false } },
  components: { ApplicationConversation, ApplicationNotes },
  created() {
    this.$store.dispatch('client/chats/fetchAll')
  },
  data() {
    return {
      colors,
      allOpportunities: true,
    }
  },
  computed: {
    ...mapGetters({
      allChats: 'client/chats/all',
    }),
    chats() {
      return this.allChats.filter(this.allOpportunities ? c => c.application.profile.id === this.application.profile.id : c => c.application.id === this.application.id)
    },
    activities() {
      if (!this.application || !this.application.activities || !this.application.activities[0])
        return []

      return this.application.activities.filter(a => (this.allOpportunities ? true : !this.isFromOtherOpportunity(a)))
    },
    unreadCandidateChats() {
      if (this.chats && this.chats[0]) {
        for (var i = 0; i < this.chats.length; i++) {
          if (this.chats[i].senderType === 'Candidate' && this.chats[i].readAt === null)
            return true  
        }
      }
      return false
    },
    showOpportunityTabs() {
      // Check for activity on other applications
      if (this.application && this.application.activities) {
        for (var i = 0; i < this.application.activities.length; i++) {
          if (this.isFromOtherOpportunity(this.application.activities[i]))
            return true
        }
      }

      // Check for messages on other applications
      return !(
        this.allChats.filter(c => c.application.profile.id === this.application.profile.id).length ==
        this.allChats.filter(c => c.application.id === this.application.id).length
      )
    },
  },
  methods: {
    toggleAll(value) { this.allOpportunities = value },
    isFromOtherOpportunity(activity) {
      if (_.get(this.application, 'opportunity.id') && _.get(activity, 'opportunity.id')) {
        return this.application.opportunity.id !== activity.opportunity.id
      }

      return false
    },
    tabNavigated(value) {
      // Refresh chats to mark them as read
      if (value === 'chats') {
        this.$store.dispatch('client/chats/fetchApplication', this.application)
      }
    },
  }
}
</script>

<style>
.tabbed-feedback .v-tabs__container .v-badge__badge {
  top: -10px;
  right: -16px;
}
</style>
